import { Injectable } from '@angular/core';
import { ReplaySubject, Subject } from 'rxjs';
import { ResolutionBreakpoints } from "src/app/modules/shared/classes/ResolutionBreakpoints";

@Injectable({
	providedIn: 'root'
})
export class HeaderService {

	private sHeight = new ReplaySubject<number|null>(1);
	public oHeight = this.sHeight.asObservable();

	/**
	 * Se emite el espacio restante en la pantalla ([altura del viewport] - [altura del header]).
	 * Excepto si el width es menor a la resolución sm (pantallas móviles).
	 * En cuyo caso se emite null como bandera para que se le asigne al carrusel una altura fija.
	 * 
	 * @param headerHeight Altura del header
	 * @emits number|null - Altura restante del viewport al restarle la altura del header, o null en tamaños de pantalla móvil
	 */
	emitHeight(headerHeight:number) {
		if (window.innerWidth >= ResolutionBreakpoints[0])
			this.sHeight.next(window.innerHeight - headerHeight);
		else
			this.sHeight.next(null);
	}

	///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

	// searchInput y clearSearchInput on dos eventos diferentes
	// El primero es para cuando el usuario hace un input
	// El segundo es para limpiar el input  programáticamente
	// No son lo mismo porque en los componentes yo quiero escuchar el evento de que un usuario cambie el texto
	//	pero no quiero escuchar a cuando se limpia el texto por el motivo que sea

	private sSearchInput = new Subject<string|null>();
	/**
	 * Observable que envía el input del usuario cada vez que escribe algo y aprieta enter
	 */
	public oSearchInput = this.sSearchInput.asObservable();

	private sClearSearchInput = new Subject<void>();
	/**
	 * Observable que envía una señal para limpiar el input en el header
	 */
	public oClearSearchInput = this.sClearSearchInput.asObservable();

	emitSearchInput(input:string|null) {
		this.sSearchInput.next(input);
	}
	emitClearSearchInput() {
		this.sClearSearchInput.next();
	}
}
